import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { H2, Loader } from '../Common'

import cool from '../../images/emojis/cool.svg'

import style from './LoginPreload.scss'

class LoginPreload extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired,
    preload: PropTypes.bool,
  }

  state = {
    canRedirect: false,
  }

  UNSAFE_componentWillMount() {
    setTimeout(() => {
      this.setState(
        () => ({
          canRedirect: true,
        }),
        () => {
          this.redirect()
        },
      )
    }, 2000)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.preload === true) {
      this.redirect(nextProps.preload)
    }
  }

  redirect = (preload = this.props.preload) => {
    if (!this.state.canRedirect || !preload) return
    window.location.href = this.props.url
  }

  render() {
    const { user } = this.props
    return (
      <div className={style.wrapper}>
        <div className={style.preload}>
          <img src={user.image || cool} alt="Emoji Feliz!" />
          <H2>Oi {user.name.split(' ')[0]}!</H2>
          <p>fique à vontade aqui na Hi Platform.</p>
          <Loader className={style.loader} />
        </div>
      </div>
    )
  }
}

export default LoginPreload



// WEBPACK FOOTER //
// ./src/components/Pages/LoginPreload.js